import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { environment } from '../../../../environment/environment';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { RLSPolicyDTO } from '../../../../dto/rls/rls-policy.dto';

export function rls_policies(componentDataSourceService: ComponentDataSourceService) {
    return {
        name: 'RLS Policies',
        description: 'Lists all RLS policies from all tables',
        execute: (params?: LoadDataParams) => {
            
            return componentDataSourceService.http.get<RLSPolicyDTO[]>(
                `${environment.apiUrl}/rls/policies`,
                params?.queryParams ? { params: params.queryParams } : {}
            ).pipe(
                catchError(error => {
                    console.error('Error fetching RLS policies:', error);
                    return of([]);
                }),
                map(policies => ({
                    items: policies.map(policy => ({
                        ...policy,
                        roles: Array.isArray(policy.roles) ? policy.roles.join(', ') : policy.roles
                    })),
                    totalCount: policies.length
                }))
            );
        },
        settings: {
            columns: [
                { key: 'table_name', header: 'Table Name', type: 'text' },
                { key: 'policy_name', header: 'Policy Name', type: 'text' },
                { key: 'roles', header: 'Roles', type: 'text' },
                { key: 'cmd', header: 'Command', type: 'text' },
                { key: 'qual', header: 'Qualifier', type: 'text', wrap: true },
                { key: 'with_check', header: 'With Check', type: 'text', wrap: true }
            ],
            pageable: true,
            sortable: true,
            rowHover: true,
            defaultSortColumn: 'table_name',
            defaultSortDirection: 'asc'
        }
    }
} 